import type { ReactNode } from 'react'

interface SectionLabelProps {
  children: ReactNode
  icon?: ReactNode
}

export function SectionLabel({ children, icon }: SectionLabelProps) {
  return (
    <div className="flex items-center gap-1">
      <p className="text-foreground-secondary type-ui-sm">{children}</p>
      {icon ? <div className="size-4 shrink-0">{icon}</div> : null}
    </div>
  )
}
